import { Component, Input } from '@angular/core';
import { IPatientHistory } from '@app/core/patient-requests';
import { ItemConfig } from '../request-detail/patient-request-detail.component';
import { defaultPatientConfig } from './default-patient-config';

@Component({
  selector: 'afoone-patient-data',
  templateUrl: './patient-data.component.html',
  styleUrls: ['./patient-data.component.css']
})
export class PatientDataComponent {
  @Input() patient: IPatientHistory;

  public config: ItemConfig[] = defaultPatientConfig;

}
